import { ContentView } from '../../../api/client'

type Props = {
    content: ContentView
    isSelected: boolean
    onSelectionChange: (content: ContentView, isSelected: boolean) => void
}

/**
 * This is used in the ContentCard component to allow the user to select content.
 */
export default function ContentSelector(props: Props) {
    const { content, isSelected, onSelectionChange } = props

    const classes = isSelected ? ' opacity-100 ' : ' opacity-0 group-hover:opacity-100 '

    return (
        <div
            className={`flex transition-opacity duration-300 items-center justify-center absolute h-full  w-12 hover:cursor-pointer  bg-[#288fcf] ${classes}`}
            onClick={() => {
                onSelectionChange(content, !isSelected)
            }}
        >
            <input
                id="comments"
                aria-describedby="comments-description"
                name="comments"
                type="checkbox"
                checked={isSelected}
                onChange={() => {
                    onSelectionChange(content, !isSelected)
                }}
                className="opacity-100 h-4 w-4 rounded border-ink-200 text-accent-2-500 focus:ring-accent-2-600"
            />
        </div>
    )
}
